import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "suggestions"];
  static values = {
    establishmentId: Number,
    currentSheetId: Number,
  };

  connect() {
    this.suggestionsTarget.hidden = true;
  }

  async checkRecipes(event) {
    const ingredientId = this.selectTarget.value;
    if (!ingredientId) return;

    const response = await fetch(
      `/establishments/${this.establishmentIdValue}/technical_sheet_suggestions?ingredient_id=${ingredientId}&current_sheet_id=${this.currentSheetIdValue}`
    );
    const data = await response.json();

    if (data.recipes && data.recipes.length > 0) {
      this.showSuggestions(data.recipes);
    } else {
      this.hideSuggestions();
    }
  }

  showSuggestions(recipes) {
    this.suggestionsTarget.innerHTML = this.buildSuggestionsHTML(recipes);
    this.suggestionsTarget.hidden = false;
  }

  hideSuggestions() {
    this.suggestionsTarget.hidden = true;
  }

  async useRecipe(event) {
    event.preventDefault();
    const recipeId = event.currentTarget.dataset.recipeId;

    // On cache les suggestions
    this.hideSuggestions();

    // On trouve le wrapper de l'ingrédient
    const ingredientWrapper = this.element.closest(".nested-fields");

    // On désactive les champs requis avant de cacher
    ingredientWrapper.querySelectorAll("[required]").forEach((field) => {
      field.required = false;
    });

    // On marque l'ingrédient comme supprimé si ce n'est pas un nouveau record
    if (ingredientWrapper.dataset.newRecord !== "true") {
      ingredientWrapper.querySelector("input[name*='_destroy']").value = "1";
    }
    ingredientWrapper.style.display = "none";

    // On déclenche un événement custom pour le nested form controller
    const customEvent = new CustomEvent("replace-with-recipe", {
      detail: { recipeId },
      bubbles: true,
    });
    this.element.dispatchEvent(customEvent);
  }

  keepIngredient(event) {
    event.preventDefault();
    this.hideSuggestions();
  }

  buildSuggestionsHTML(recipes) {
    return `
      <div class="alert alert-warning shadow-lg mt-2">
        <div class="flex-1">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div>
            <h3 class="font-bold">Recettes existantes trouvées !</h3>
            <div class="text-sm">
              Cet ingrédient est utilisé dans ${recipes.length} recette(s) :
            </div>
            <ul class="mt-2 space-y-2">
              ${recipes
                .map(
                  (recipe) => `
                <li class="flex items-center justify-between">
                  <span class="text-sm">
                    ${recipe.name} 
                    <span class="opacity-70">(${recipe.ingredient_quantity}${recipe.ingredient_unit})</span>
                  </span>
                  <button class="btn btn-sm btn-warning" 
                          data-action="click->ingredient-suggestions#useRecipe"
                          data-recipe-id="${recipe.id}">
                    Utiliser comme sous-recette
                  </button>
                </li>
              `
                )
                .join("")}
            </ul>
            <div class="mt-4">
              <button class="btn btn-sm btn-ghost" 
                      data-action="click->ingredient-suggestions#keepIngredient">
                Continuer avec l'ingrédient
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
